import { createContext } from "react";
export function endReasonToString(endReason) {
    switch (endReason) {
        case "CREWMATES_BY_TASK":
            return "クルーメイトのタスク勝利";
        case "CREWMATES_BY_VOTE":
            return "クルーメイトの全狼釣り勝利";
        case "IMPOSTORS_BY_KILL":
            return "インポスターのキル勝利";
        case "IMPOSTORS_BY_SABOTAGE":
            return "インポスターのサボタージの時間切れ勝利";
        case "IMPOSTORS_BY_VOTE":
            return "インポスターのクルーメイト釣り勝利";
        case "IMPOSTOR_DISCONNECT":
            return "クルーメイトのインポスター回線切断勝利";
        case "CREWMATE_DISCONNECT":
            return "インポスターのクルーメイト回線切断勝利";
        default:
            return `Unknown Reason (${endReason})`;
    }
}
export const DataContext = createContext(undefined /* FAKE */);
export const ResConfigContext = createContext(undefined);
